import React, { useState, useEffect } from 'react';
import { VentroIcon, MenuIcon, CloseIcon, SunIcon, MoonIcon } from './Icons.tsx';
import { useTheme } from '../App.tsx';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = ['Features', 'Testimonials', 'FAQ'];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || isMenuOpen ? 'bg-white/80 dark:bg-black/50 backdrop-blur-lg border-b border-gray-200 dark:border-gray-800' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6 py-4">
        <div className="flex justify-between items-center">
          <a href="#" className="flex items-start gap-2">
            <VentroIcon className="h-10 w-10 text-orange-600 dark:text-[#FF4D00]" />
            <div className="flex flex-col pt-2">
              <span className="text-xl font-bold text-gray-900 dark:text-white leading-tight">Shield</span>
              <span className="text-xs text-gray-500 dark:text-white leading-tight">by Ventro</span>
            </div>
          </a>
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a key={link} href={`#${link.toLowerCase()}`} className="text-gray-700 dark:text-gray-300 hover:text-black dark:hover:text-white transition-colors">
                {link}
              </a>
            ))}
          </nav>
          <div className="hidden md:flex items-center gap-4">
            <button onClick={toggleTheme} className="text-gray-700 dark:text-gray-300 hover:text-black dark:hover:text-white transition-colors p-2 rounded-full">
              {theme === 'light' ? <MoonIcon className="h-5 w-5" /> : <SunIcon className="h-5 w-5" />}
            </button>
            <a href="#" className="text-gray-700 dark:text-gray-300 hover:text-black dark:hover:text-white transition-colors">
              Log In
            </a>
            <a
              href="#"
              className="bg-orange-600 text-white dark:bg-[#FF4D00] dark:text-black font-semibold px-5 py-2 rounded-lg hover:bg-orange-700 dark:hover:bg-white transition-all duration-300 transform hover:scale-105 shadow-lg shadow-orange-600/30 dark:shadow-lg dark:shadow-[#FF4D00]/30"
            >
              Get Started Free
            </a>
          </div>
          <div className="md:hidden flex items-center gap-2">
            <button onClick={toggleTheme} className="text-gray-800 dark:text-white">
              {theme === 'light' ? <MoonIcon className="h-6 w-6" /> : <SunIcon className="h-6 w-6" />}
            </button>
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-800 dark:text-white">
              {isMenuOpen ? <CloseIcon className="h-6 w-6" /> : <MenuIcon className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>
      {isMenuOpen && (
        <div className="md:hidden bg-white/95 dark:bg-black/80 backdrop-blur-lg pb-8">
          <nav className="flex flex-col items-center gap-6 pt-4">
            {navLinks.map((link) => (
              <a
                key={link}
                href={`#${link.toLowerCase()}`}
                onClick={() => setIsMenuOpen(false)}
                className="text-gray-700 dark:text-gray-300 hover:text-black dark:hover:text-white transition-colors text-lg"
              >
                {link}
              </a>
            ))}
            <a href="#" className="text-gray-700 dark:text-gray-300 hover:text-black dark:hover:text-white transition-colors text-lg">
              Log In
            </a>
            <a
              href="#"
              className="bg-orange-600 text-white dark:bg-[#FF4D00] dark:text-black font-semibold px-6 py-3 rounded-lg hover:bg-orange-700 dark:hover:bg-white transition-all duration-300 transform hover:scale-105 w-4/5 text-center shadow-lg shadow-orange-600/30 dark:shadow-lg dark:shadow-[#FF4D00]/30"
            >
              Get Started Free
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;